module.exports = new __parcel__URL__("azure-logomark.345a3a45.svg").toString();